// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nvFj","colMin":"styles_colMin__2_dXu"};